import { FormSectionHeader, Loader, NoData } from "@/components";
import { Button, Card, CardContent } from "@/components/ui";
import useDownloadTemplate from "./useDownloadTemplate";
import { ArrowDownToLine } from "lucide-react";

const DownloadTemplate = ({configFields, currentConfig, isLoading}: {configFields: any, currentConfig: any, isLoading?: boolean}) => {
  const {headerFields, lineItemFields, templateMetadata, onDownload, isReportExportLoading} = useDownloadTemplate({configFields, currentConfig});

  return (
    <Card>
      {isLoading ? <Loader /> : 
        <CardContent>
          <FormSectionHeader className="text-black" wrapperClassName="mb-0">Document Template</FormSectionHeader>
          <span className="text-[12px] text-g-400">Template structure changes based on selected document type and configuration.</span>

          {currentConfig ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-10 mt-6 gap-5">
            <div className="lg:col-span-6 border rounded-md p-3">
              <FormSectionHeader>Template Preview</FormSectionHeader>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="bg-blue-50 border border-blue-200 rounded-md p-3">
                  <FormSectionHeader className="text-[14px]">Header Fields</FormSectionHeader>
                  <div className="text-[12px] text-g-400 flex flex-col gap-2">
                    {headerFields?.map((data: any) => {
                        return <span>{data?.displayLabel}</span>
                    })}
                  </div>
                </div>
                <div className="bg-blue-50 border border-blue-200 rounded-md p-3">
                  <FormSectionHeader className="text-[14px]">Line Item Fields</FormSectionHeader>
                  <div className="text-[12px] text-g-400 flex flex-col gap-2">
                    {lineItemFields?.map((data: any) => {
                        return <span>{data?.displayLabel}</span>
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:col-span-4 bg-primary text-white rounded-md p-3">
              <FormSectionHeader>Template Metadata</FormSectionHeader>
              <div className="flex flex-col gap-2">
                {
                  templateMetadata?.map((data: any) => {
                    return <div className="flex flex-row gap-3 items-center">
                      <span className="text-[14px] font-[300] lg:min-w-[150px] text-white/80">{data?.label}</span>
                      <span>:</span>
                      <span className="text-[16px]">{data?.value}</span>
                    </div>
                  })
                }
              </div>
              <div className="flex items-center mt-5 w-full">
                <Button 
                  className="bg-white text-black hover:bg-white/90 hover:text-black w-full"
                  disabled={isReportExportLoading}
                  onClick={onDownload}
                ><ArrowDownToLine /> Download Template</Button>
              </div>
            </div>
          </div> : 
          <div className="py-8">
            <NoData />
          </div>}
        </CardContent>
      }
    </Card>
  )
}

export default DownloadTemplate;